<template>
  <div
    class="container-fluid d-flex justify-content-center align-items-center"
    style="height: 100vh; background-color: #f3f3f3"
  >
    <div
      v-for="(circle, index) in circles"
      :key="index"
      class="circle"
      :style="{
        left: circle.x + 'px',
        top: circle.y + 'px',
        width: circle.size + 'px',
        height: circle.size + 'px',
        backgroundColor: circle.color
      }"
    ></div>
    <div class="card login shadow-lg border-0">
      <div class="row my-4" style="height: 100%">
        <!-- Login Panel -->
        <div
          class="col-md-12 d-flex justify-content-center align-items-center p-0"
        >
          <div class="col-sm-10 col-xl-8 col-md-9 col-11">
            <div
              class="h-100 w-100 d-flex justify-content-center align-items-center rounded-right mt-2"
            >
              <div
                class="bg-white rounded-circle d-flex justify-content-center align-items-center"
                style="z-index: 4; max-width: 50%; height: auto"
              >
                <img
                  :src="require('@/assets/img/logo.png')"
                  class="img-fluid img-shadow"
                  alt="main_logo"
                />
              </div>
            </div>
            <div class="text-center mb-4">
              <h3 class="font-weight-bolder fs-4">Iniciar sesión</h3>
            </div>
            <form
              @submit.prevent="OnSubmit"
              role="form"
              class="col-xl-9 mx-auto"
            >
              <div class="mb-3">
                <label class="form-label">Correo</label>
                <input
                  v-model="model.email"
                  type="email"
                  class="form-control border-info"
                  placeholder="Escribe tu correo"
                  aria-label="Email"
                  aria-describedby="email-addon"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Contraseña</label>
                <div class="input-group">
                  <input
                    v-model="model.password"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control border-info"
                    placeholder="Escribe tu contraseña"
                    aria-label="Password"
                    aria-describedby="password-addon"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-info text-info border-info py-0 px-3"
                      :class="{
                        'bi bi-eye-slash-fill': !showPassword,
                        'bi bi-eye-fill': showPassword
                      }"
                      type="button"
                      style="
                        border-radius: 0px 7px 7px 0px;
                        border-width: 1px;
                        border-left: 0px;
                      "
                      @click.prevent="toggleVisibility()"
                    ></button>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button
                  type="submit"
                  class="btn btn-fill btn-info mt-4 mb-4 w-100 font-weigh-normal"
                  style="border-radius: 8px"
                >
                  Acceder
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapActions } from 'vuex'
import validator from 'email-validator'

export default {
  name: 'Login',
  data() {
    return {
      circles: [],
      animationFrameId: null,
      lastTime: 0,

      // -----------------------

      showPassword: false,
      model: {
        email: '',
        password: ''
      }
    }
  },
  beforeUnmount() {
    cancelAnimationFrame(this.animationFrameId)
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    const colors = ['#f76e2a', '#e72652', '#f0c505', '#8cc540', '#7b1189']
    for (let i = 0; i < 9; i++) {
      this.circles.push({
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        vx: (Math.random() - 0.5) * 4,
        vy: (Math.random() - 0.5) * 4,
        size: 50 + Math.random() * 50,
        color: colors[Math.floor(Math.random() * colors.length)],
        mass: 1
      })
    }

    this.startAnimation()
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(['login']),

    startAnimation() {
      const animate = (currentTime) => {
        if (this.lastTime) {
          const deltaTime = (currentTime - this.lastTime) / 16 // normalize to ~60fps
          this.updatePositions(deltaTime)
          this.checkCollisions()
        }
        this.lastTime = currentTime
        this.animationFrameId = requestAnimationFrame(animate)
      }
      this.animationFrameId = requestAnimationFrame(animate)
    },
    updatePositions(deltaTime) {
      const containerWidth = window.innerWidth // Ancho total de la ventana
      const containerHeight = window.innerHeight // Altura total de la ventana

      this.circles.forEach((circle) => {
        // Actualizar posición
        circle.x += circle.vx * deltaTime
        circle.y += circle.vy * deltaTime

        // Rebotar en las paredes del contenedor dinámico
        if (circle.x <= 0) {
          circle.x = 0
          circle.vx = Math.abs(circle.vx)
        }
        if (circle.x >= containerWidth - circle.size) {
          circle.x = containerWidth - circle.size
          circle.vx = -Math.abs(circle.vx)
        }
        if (circle.y <= 0) {
          circle.y = 0
          circle.vy = Math.abs(circle.vy)
        }
        if (circle.y >= containerHeight - circle.size) {
          circle.y = containerHeight - circle.size
          circle.vy = -Math.abs(circle.vy)
        }
      })
    },
    checkCollisions() {
      for (let i = 0; i < this.circles.length; i++) {
        for (let j = i + 1; j < this.circles.length; j++) {
          const circle1 = this.circles[i]
          const circle2 = this.circles[j]

          const dx = circle2.x - circle1.x
          const dy = circle2.y - circle1.y
          const distance = Math.sqrt(dx * dx + dy * dy)

          if (distance < (circle1.size + circle2.size) / 2) {
            // Collision detected - calculate new velocities
            const angle = Math.atan2(dy, dx)
            const sin = Math.sin(angle)
            const cos = Math.cos(angle)

            // Rotate velocities
            const vx1 = circle1.vx * cos + circle1.vy * sin
            const vy1 = circle1.vy * cos - circle1.vx * sin
            const vx2 = circle2.vx * cos + circle2.vy * sin
            const vy2 = circle2.vy * cos - circle2.vx * sin

            // Collision reaction
            const finalVx1 =
              ((circle1.mass - circle2.mass) * vx1 + 2 * circle2.mass * vx2) /
              (circle1.mass + circle2.mass)
            const finalVx2 =
              ((circle2.mass - circle1.mass) * vx2 + 2 * circle1.mass * vx1) /
              (circle1.mass + circle2.mass)

            // Rotate velocities back
            circle1.vx = finalVx1 * cos - vy1 * sin
            circle1.vy = vy1 * cos + finalVx1 * sin
            circle2.vx = finalVx2 * cos - vy2 * sin
            circle2.vy = vy2 * cos + finalVx2 * sin

            // Move circles apart to prevent sticking
            const overlap = (circle1.size + circle2.size) / 2 - distance
            const moveX = (overlap * dx) / distance / 2
            const moveY = (overlap * dy) / distance / 2

            circle1.x -= moveX
            circle1.y -= moveY
            circle2.x += moveX
            circle2.y += moveY
          }
        }
      }
    },
    handleResize() {
      this.circles.forEach((circle) => {
        // Asegurar que los círculos sigan dentro de la ventana redimensionada
        circle.x = Math.min(circle.x, window.innerWidth - circle.size)
        circle.y = Math.min(circle.y, window.innerHeight - circle.size)
      })
    },
    toggleVisibility() {
      this.showPassword = !this.showPassword
    },

    OnSubmit() {
      if (this.model.email === '' || this.model.password === '') {
        Swal.fire({
          title: 'Atención',
          text: 'Complete todos los campos para continuar',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn-info'
          }
        })
        return
      }

      if (!validator.validate(this.model.email)) {
        Swal.fire({
          title: 'Atención',
          text: 'El correo electrónico no es válido',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn-info'
          }
        })
        return
      }

      Swal.showLoading()
      this.login(this.model)
        .then((response) => {
          if (response.code === 200) {
            this.$router.push('/admin/overview')
            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            })
            Toast.fire({
              icon: 'success',
              title: '¡Bienvenido!',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (response.code === 403) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Este usuario no puede acceder al panel administrativo',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (response.code === 402) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else {
            Swal.fire({
              title: 'Ocurrió un error',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.code === 402) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (error.code === 403) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Este usuario no puede acceder al panel administrativo',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (error.code === 404) {
            Swal.fire({
              title: 'Usuario no encontrado',
              text: 'No se encuentra un usuario activo con estos datos',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else {
            Swal.fire({
              title: 'Ocurrió un error',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          }
        })
    }
  }
}
</script>

<style>
.animation {
  width: 300px;
  height: 400px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  margin: 20px auto;
}

.container-fluid {
  position: relative;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  will-change: transform;
}

.login {
  background-size: cover;
}

.gradient {
  background: linear-gradient(135deg, #ffffff00 0%, #a603ac60 100%);
}

.img-shadow {
  filter: drop-shadow(0px 0px 3px rgba(92, 44, 0, 0.247));
}

/* haz un media query para cambiar el width de la card dependiendo del dispositivo lg 50% whidth sm 80% */
/* Media query para dispositivos grandes (lg) */
@media (min-width: 1000px) {
  .login {
    width: 50%; /* ancho para dispositivos grandes */
  }
}
/* Media query para dispositivos pequeños (sm) */
@media (max-width: 768px) {
  .login {
    width: 85%; /* ancho para dispositivos pequeños */
  }
}
</style>
